<script>
import PopperModal from "@/components/elements/PopperModal.vue";
import {AlertService} from "@/services/AlertService";
import DateMixin from "@/mixins/DateMixin";
import AuditorMixin from "@/mixins/AuditorMixin";
import SearchDropdown from "@/components/modules/ia/SearchDropdown.vue";
import {mapActions, mapGetters} from "vuex";
import MultiSelectCustom from "@/components/MultiSelectCustom";
import OtherComp from "@/components/elements/OtherComp.vue";
import ImageComp from "@/components/elements/ImageComp.vue";

export default {
  name: "AddAuditor",
  components: {ImageComp, OtherComp, MultiSelectCustom, PopperModal, SearchDropdown},
  mixins:[DateMixin, AuditorMixin],
  data() {
    return {
      isSubmitting: false,
      newAuditor : {
        honorifics                      : '',
        first_name                      : '',
        last_name                       : '',
        middle_name                     : '',
        suffix                          : '',
        email                           : '',
        contact_number                  : '',
        auditor_department_id           : null,
        auditor_position_id             : null,
        management_office_id            : null,
        is_designated_person            : 0,
        dp_branch_office_id             : null,
        audit_types                     : [],
        lead_types                     : [],
        management_office               : null,
        is_internal_of_external_auditor : false,
        is_lead                         : false,
        is_active                       : true,
        lead_ids                        : [],
        members_ids                     : [],
        certificates: [],
        dp_certificates: [],
        force_create: false,
      },
      searchedUser : [],
    }
  },
  methods: {
    ...mapActions(['getAllUsers', 'defineSelectedUser', 'getMngmtOfficeKeys', 'createAuditor']),
    truncateText(text, length) {
      if (text.length > length) {
        return text.substring(0, length) + '...';
      }
      return text;
    },
    async cancelAdd() {
      const response= await AlertService.cancelAlert();
      if(response){
        $('#AddNewAuditorModal').modal('hide');
        this.resetNewAuditor();
      }
    },
    resetNewAuditor() {
      this.newAuditor = {
        honorifics                      : '',
        first_name                      : '',
        last_name                       : '',
        middle_name                     : '',
        suffix                          : '',
        email                           : '',
        contact_number                  : '',
        auditor_department_id           : null,
        auditor_position_id             : null,
        management_office_id            : null,
        is_designated_person            : 0,
        dp_branch_office_id             : null,
        audit_types                     : [],
        lead_types                     : [],
        management_office               : null,
        is_internal_of_external_auditor : false,
        is_lead                         : false,
        is_active                       : true,
        lead_ids                        : [],
        members_ids                     : [],
        certificates: []
      }
      this.$refs.auditor_certificate.value = '';
    },
    async setSelectedItem(data) {
      const user = await this.getUserForAuditor(data.id);

      this.searchedUser = [];
      this.newAuditor.first_name = user.first_name;
      this.newAuditor.last_name = user.last_name;
      this.newAuditor.middle_name = user.middle_name;
      this.newAuditor.suffix = user.suffix ?? '';
      this.newAuditor.email = user.email;
      this.newAuditor.contact_number = user.contact_number ?? '';
      this.newAuditor.auditor_department_id = user.auditor_department_id ?? null;
      this.newAuditor.auditor_position_id = user.auditor_position_id ?? null;
      this.newAuditor.management_office_id = user.management_office_id;
      this.setAuditorManagementOffice(user.management_office_id);
      this.newAuditor.is_internal_of_external_auditor = user.is_internal_of_external_auditor ?? false;
      this.newAuditor.is_lead = user.is_lead ?? false;
      this.newAuditor.is_active = user.is_active ?? true;
      this.newAuditor.lead_ids = user.lead_ids ?? [];
      this.newAuditor.members_ids = user.members_ids ?? [];
      this.newAuditor.certificates = user.certificates ? user.certificates.map(cert => ({ ...cert, issued_date: null, expiration_date: null })) : [];
      this.$refs.auditor_certificate.value = '';
    },
    setAuditorManagementOffice(managementOfficeId) {
      let managementOffice = this.mngmntOfficeKeys.filter((managementOffice) => {
        return managementOffice.id === managementOfficeId;
      });
      managementOffice = managementOffice.length === 0 ? null : managementOffice[0];
      this.newAuditor.management_office = managementOffice;
    },
    async searchUserOrAuditor(value) {
      await this.getAllUsers({
        search : value,
        for_auditor_module : true
      });
      this.searchedUser = [];
      this.searchedUser.push(...this.allUsers);
    },
    setAuditorCertificate() {
      const files = this.$refs.auditor_certificate.files;

      if (files.length > 0) {
        let allFilesArePdf = true;
        for (let i = 0; i < files.length; i++) {
          if (files[i].type !== 'application/pdf') {
            allFilesArePdf = false;
            break;
          }
        }

        if (allFilesArePdf) {
          for (let i = 0; i < files.length; i++) {
            this.newAuditor.certificates.push({
              file: files[i],
              file_name: files[i].name,
              issued_date: null,
              expiration_date: null,
            });
          }
        } else {
          AlertService.errorAlert("Only PDF files are supported.", "Unsupported File Type");
          this.$refs.auditor_certificate.value = '';
        }
      }
    },
    setDpAuditorCertificate() {
      const files = this.$refs.dp_auditor_certificate.files;

      if (files.length > 0) {
        let allFilesArePdf = true;

        for (let i = 0; i < files.length; i++) {
          if (files[i].type !== 'application/pdf') {
            allFilesArePdf = false;
            break;
          }
        }

        if (allFilesArePdf) {
          for (let i = 0; i < files.length; i++) {
            this.newAuditor.dp_certificates.push({
              file: files[i],
              file_name: files[i].name,
              issued_date: null,
              expiration_date: null,
            });
          }
        } else {
          AlertService.errorAlert(
            "Only PDF files are supported.",
            "Unsupported File Type"
          );
          this.$refs.dp_auditor_certificate.value = '';
        }
      }
    },
    removeNewCertificate(index) {
      this.newAuditor.certificates.splice(index, 1);
      if (this.newAuditor.certificates.length === 0) {
        this.$refs.auditor_certificate.value = '';
      }
    },
    removeDpCertificate(index) {
      this.newAuditor.dp_certificates.splice(index, 1);
      if (this.newAuditor.dp_certificates.length === 0) {
        this.$refs.dp_auditor_certificate.value = '';
      }
    },
    async createNewAuditor() {
      if (this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;

      try {
        let param = Object.assign({}, this.newAuditor);

        let formData = new FormData();
        for (const key in param) {
          if (key === 'certificates' && param.certificates.length > 0) {
            param.certificates.forEach((cert, index) => {
              formData.append(`certificate_files[${index}]`, cert.file);
              formData.append(`certificate_issued_dates[${index}]`, cert.issued_date || '');
              formData.append(`certificate_expiration_dates[${index}]`, cert.expiration_date || '');
            });
          }
          else if (key === 'dp_certificates' && param.dp_certificates.length > 0) {
            param.dp_certificates.forEach((cert, index) => {
              formData.append(`dp_certificate_files[${index}]`, cert.file);
              formData.append(`dp_certificate_issued_dates[${index}]`, cert.issued_date || '');
              formData.append(`dp_certificate_expiration_dates[${index}]`, cert.expiration_date || '');
              formData.append(`is_designated_person_certificate[${index}]`, 1);
            });
          } else if (key !== 'certificates' && key !== 'dp_certificates') {
            if (key === 'is_internal_of_external_auditor' || key === 'is_lead' || key === 'is_active') {
              formData.append(key, param[key] ? 1 : 0);
            } else {
              if (key === 'audit_types' || key === 'lead_types') {
                param[key].forEach((item, item_key ) => {
                  formData.append(key + `[${item_key}]`, item);
                })
              } else {
                formData.append(key, param[key] === null ? '' : param[key]);
              }
            }
          }
        }

        let createResponse = await this.createAuditor(formData);

        if (createResponse.duplicate === true) {

          const proceed = await AlertService.confirmCreateAlert(
            createResponse.message + "\n Do you want to continue?",
            'Yes, Continue',
            'Duplicate Auditor'
          );

          if (!proceed) {
            return;
          }

          formData.set('force_create', 1);

          createResponse = await this.createAuditor(formData);

          if (!createResponse.result) {
            return AlertService.errorAlert(createResponse.message, 'ADDING OF AUDITOR');
          }


        } else if (!createResponse.result) {

          return AlertService.errorAlert(createResponse.message, 'ADDING OF AUDITOR');
        }

        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
        $('.fade').remove();
        $('.show').remove();

        successAlert.fire({
          title: `ADDING OF AUDITOR SUCCESS`,
          showConfirmButton: true,
          allowOutsideClick:false,
          allowEnterKey:false,
          allowEscapeKey:false,
          scrollbarPadding: false
        }).then(async (result)=>{
          if(result.isConfirmed){
            if (this.$route.name !== 'AuditorGeneralInfo') {
              await this.$router.push({
                name: 'AuditorGeneralInfo',
                params: {
                  id: createResponse.data.id
                }})
            }

            return;
          }

          if (this.$route.name !== 'AuditorGeneralInfo') {
            await this.$router.push({
              name: 'AuditorGeneralInfo',
              params: {
                id: createResponse.data.id
              }})
          }
        });


      } finally {
        this.isSubmitting = false;
      }
    },
    setLeadMembers(leadMemberIds) {
      this.newAuditor.lead_ids = leadMemberIds.selected
    },
    setNonLeadMembers(nonLeadMemberIds) {
      this.newAuditor.members_ids = nonLeadMemberIds.selected;
    },
    resetLeadsAndMembers() {
      this.newAuditor.lead_ids = [];
      this.newAuditor.members_ids = [];
    },
    changeDesignatedPerson() {
      this.newAuditor.dp_branch_office_id = null;
      this.newAuditor.audit_types = [];
    }
  },
  async created() {
    await this.getMngmtOfficeKeys();
  },
  computed: {
    ...mapGetters(['allUsers', 'mngmntOfficeKeys', 'leadAuditors', 'nonLeadAuditors']),
  },
}
</script>

<template>
  <div class="modal fade" data-backdrop="static" data-keyboard="false" id="AddNewAuditorModal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <form class="modal-content" @submit.prevent="createNewAuditor">
        <div class="modal-header">
          <div class="modal-title w-100 text-center">
            <h5 class="font-weight-bold">Add New Auditor</h5>
          </div>
        </div>
        <div class="modal-body">
          <div class="form-group row no-gutters mb-1">
            <label for="first_name" class="font-weight-bold col-sm-3 col-form-label">Search User</label>
            <div class="col-sm-9">
              <search-dropdown
                :items="searchedUser"
                @setSelectedItem="setSelectedItem"
                @setSearchTerm="searchUserOrAuditor"
              />
            </div>
          </div>

          <!--          FOR HONORIFICS-->
          <div class="form-group row no-gutters mb-1">
            <label for="honorifics" class="font-weight-bold col-sm-3 col-form-label">Honorifics</label>
            <div class="col-sm-9">
              <input type="text" id="honorifics" class="form-control form-control-sm" v-model="newAuditor.honorifics">
            </div>
          </div>
          <!--          FOR FIRST NAME-->
          <div class="form-group row no-gutters mb-1">
            <label for="first_name" class="font-weight-bold col-sm-3 col-form-label">
              <sub class="lead e-text-red font-weight-bold">*</sub> First Name
            </label>
            <div class="col-sm-9">
              <input type="text" id="first_name" class="form-control form-control-sm" required v-model="newAuditor.first_name">
            </div>
          </div>
          <div class="form-group row no-gutters mb-1">
            <label for="last_name" class="font-weight-bold col-sm-3 col-form-label">
              <sub class="lead e-text-red font-weight-bold">*</sub> Last Name
            </label>
            <div class="col-sm-9">
              <input type="text" id="last_name" class="form-control form-control-sm" required v-model="newAuditor.last_name">
            </div>
          </div>
          <div class="form-group row no-gutters mb-1">
            <label for="middle_name" class="font-weight-bold col-sm-3 col-form-label">Middle Name</label>
            <div class="col-sm-9">
              <input type="text" id="middle_name" class="form-control form-control-sm" v-model="newAuditor.middle_name">
            </div>
          </div>
          <div class="form-group row no-gutters mb-1">
            <label for="extension" class="font-weight-bold col-sm-3 col-form-label">Suffix</label>
            <div class="col-sm-9">
              <input type="text" id="extension" class="form-control form-control-sm" placeholder="e.g. Jr., Sr." v-model="newAuditor.suffix">
            </div>
          </div>
          <div class="form-group row no-gutters mb-1">
            <label for="email" class="font-weight-bold col-sm-3 col-form-label">Contact Number</label>
            <div class="col-sm-9">
              <input type="text" id="email" class="form-control form-control-sm" v-model="newAuditor.contact_number">
            </div>
          </div>
          <div class="form-group row no-gutters mb-1">
            <label for="email" class="font-weight-bold col-sm-3 col-form-label">
              <sub class="lead e-text-red font-weight-bold">*</sub> Email
            </label>
            <div class="col-sm-9">
              <input type="email" id="email" class="form-control form-control-sm" v-model="newAuditor.email">
            </div>
          </div>
          <div class="form-group row no-gutters mb-1">
            <label for="auditor_department_id" class="font-weight-bold col-sm-3 col-form-label">
              <sub class="lead e-text-red font-weight-bold">*</sub> Department
            </label>
            <div class="col-sm-9">
              <select class="form-control form-control-sm text-uppercase" id="auditor_department_id" v-model="newAuditor.auditor_department_id">
                <option :value="null">—— Select Department ——</option>
                <option v-for="department in auditor_departments" :key="department.id" :value="department.id">
                  {{ department.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row no-gutters mb-1">
            <label for="auditor_position_id" class="font-weight-bold col-sm-3 col-form-label">
              <sub class="lead e-text-red font-weight-bold">*</sub> Position
            </label>
            <div class="col-sm-9">
              <select class="form-control form-control-sm text-uppercase" id="auditor_position_id" v-model="newAuditor.auditor_position_id">
                <option :value="null">—— Select Position ——</option>
                <option v-for="position in auditor_positions" :key="position.id" :value="position.id">
                  {{ position.name }}
                </option>
              </select>
            </div>
          </div>

          <!--          FOR MANAGEMENT OFFICE -->
          <div class="form-group row no-gutters mb-1">
            <label for="management_office_id" class="font-weight-bold col-sm-3 col-form-label">
              <sub class="lead e-text-red font-weight-bold">*</sub> Management Office
            </label>
            <div class="col-sm-9">
              <select class="form-control form-control-sm text-uppercase" id="management_office_id" v-model="newAuditor.management_office_id" @change="setAuditorManagementOffice(newAuditor.management_office_id)">
                <option :value="null">—— Select Management Office ——</option>
                <option v-for="mngmntOffice in mngmntOfficeKeys" :key="mngmntOffice.id" :value="mngmntOffice.id">
                  {{ mngmntOffice.name }}
                </option>
              </select>
            </div>
          </div>

          <!--          FOR DESIGNATED PERSON -->
          <div class="form-group row no-gutters mb-1">
            <label for="management_office_id" class="font-weight-bold col-sm-3 col-form-label">Designated Person (D.P.)</label>
            <div class="col-sm-9">
              <select class="form-control form-control-sm text-uppercase" id="auditor_position_id" v-model="newAuditor.is_designated_person" @change="changeDesignatedPerson">
                <option :value="1">Yes</option>
                <option :value="0">No</option>
              </select>
            </div>
          </div>

          <template v-if="newAuditor.is_designated_person === 1">
            <!--          FOR DP BRANCH OFFICE -->
            <div class="form-group row no-gutters mb-1">
              <label for="management_office_id" class="font-weight-bold col-sm-3 col-form-label">(D.P.) Branch Office</label>
              <div class="col-sm-9">
                <select class="form-control form-control-sm text-uppercase" id="management_office_id" v-model="newAuditor.dp_branch_office_id">
                  <option :value="null">—— Select DP Branch Office ——</option>
                  <option v-for="branchoffice in mngmntOfficeKeys" :key="branchoffice.id" :value="branchoffice.id">
                    {{ branchoffice.name }}
                  </option>
                </select>
              </div>
            </div>

            <!--          FOR AUDIT TYPES -->
            <div class="form-group row no-gutters mb-1">
              <label for="audit_types" class="font-weight-bold col-sm-3 col-form-label">(D.P.) Audit Types</label>
              <div class="form-group row no-gutters mb-1">
                <div class="form-check form-check-inline">
                  <input class="form-check-input checkbox-input" type="checkbox" value="sms" id="audit_type_sms" v-model="newAuditor.audit_types">
                  <label for="audit_type_sms" class="font-weight-bold col-m-3 col-form-label no-select cursor-pointer">SMS</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input checkbox-input" type="checkbox" value="isps" id="audit_type_isps" v-model="newAuditor.audit_types">
                  <label for="audit_type_isps" class="font-weight-bold col-m-3 col-form-label no-select cursor-pointer">ISPS</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input checkbox-input" type="checkbox" value="cyber" id="audit_type_cyber" v-model="newAuditor.audit_types">
                  <label for="audit_type_cyber" class="font-weight-bold col-m-3 col-form-label no-select cursor-pointer">CYBER</label>
                </div>
              </div>
            </div>

            <!-- FOR DP CERTIFICATES -->
            <div class="form-group row no-gutters mb-1">
              <label class="font-weight-bold col-sm-3 col-form-label">(D.P.) Certificates</label>
              <div class="col-sm-9 d-flex align-items-center">
                <button type="button" class="btn btn-sm btn-success" onclick="document.getElementById('dp-file-input').click()">Add Attachments
                </button>
                <input type="file" multiple class="d-none" id="dp-file-input" ref="dp_auditor_certificate" accept="application/pdf" @change="setDpAuditorCertificate">
                <span class="ml-2" v-if="newAuditor.dp_certificates.length > 0">{{ newAuditor.dp_certificates.length }} file{{ newAuditor.dp_certificates.length === 1 ? '' : 's' }}</span></div>
            </div>
            <div class="row">
              <div v-for="(certificate, index) in newAuditor.dp_certificates" :key="'dp-' + index" class="col-12 col-md-6 mb-3"><div class="p-2 border rounded">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="font-weight-bold">
                      <font-awesome-icon icon="file-pdf" size="2x" class="force-danger-all mr-2"/><span :title="certificate.file_name">{{ truncateText(certificate.file_name, 30) }}</span></p>
                    <button type="button" class="btn btn-sm btn-secondary position-absolute" style="top:0; right:0; margin-right:15px;" @click="removeDpCertificate(index)">X
                    </button>
                  </div>
                  <div class="form-group row no-gutters mb-1">
                    <label :for="'dp-issued-date-' + index" class="font-weight-bold col-sm-4 col-form-label">Issued Date</label>
                    <div class="col-sm-8">
                      <input type="date" class="form-control form-control-sm" :id="'dp-issued-date-' + index" v-model="certificate.issued_date" @keydown.enter.prevent>
                    </div>
                  </div>
                  <div class="form-group row no-gutters mb-1">
                    <label :for="'dp-expiration-date-' + index" class="font-weight-bold col-sm-4 col-form-label">Expiry Date</label>
                    <div class="col-sm-8">
                      <input type="date" class="form-control form-control-sm" :id="'dp-expiration-date-' + index" v-model="certificate.expiration_date" @keydown.enter.prevent>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!--          FOR INTERNAL OF EXTERNAL AUDITOR -->
          <div class="form-group row no-gutters mb-1">
            <label for="is_internal_of_external_auditor" class="font-weight-bold col-sm-3 col-form-label">External Auditor?</label>
            <div class="col-sm-9">
              <select class="form-control form-control-sm text-uppercase" id="is_internal_of_external_auditor" v-model="newAuditor.is_internal_of_external_auditor">
                <option :value="true">Yes</option>
                <option :value="false">No</option>
              </select>
            </div>
          </div>
          <!--          FOR AN AUDITOR LEAD -->
          <div class="form-group row no-gutters mb-1">
            <label for="management_office_id" class="font-weight-bold col-sm-3 col-form-label">Is Auditor Lead?</label>
            <div class="col-sm-9">
              <select class="form-control form-control-sm text-uppercase" id="is_lead" v-model="newAuditor.is_lead" @change="resetLeadsAndMembers">
                <option :value="true">Yes</option>
                <option :value="false">No</option>
              </select>
            </div>
          </div>

          <div class="form-group row no-gutters mb-1" v-if="newAuditor.is_lead">
            <label for="lead_types" class="font-weight-bold col-sm-3 col-form-label">Lead Types</label>
            <div class="form-group row no-gutters mb-1">
              <div class="form-check form-check-inline">
                <input class="form-check-input checkbox-input" type="checkbox" value="sms" id="lead_type_sms" v-model="newAuditor.lead_types">
                <label for="lead_type_sms" class="font-weight-bold col-m-3 col-form-label no-select cursor-pointer">SMS</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input checkbox-input" type="checkbox" value="isps" id="lead_type_isps" v-model="newAuditor.lead_types">
                <label for="lead_type_isps" class="font-weight-bold col-m-3 col-form-label no-select cursor-pointer">ISPS</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input checkbox-input" type="checkbox" value="cyber" id="lead_type_cyber" v-model="newAuditor.lead_types">
                <label for="lead_type_cyber" class="font-weight-bold col-m-3 col-form-label no-select cursor-pointer">CYBER</label>
              </div>
            </div>
          </div>

<!--          <div class="form-group row no-gutters mb-1">-->
<!--            <label for="lead_or_not_lead" class="font-weight-bold col-sm-3 col-form-label">-->
<!--              {{ newAuditor.is_lead === true ? 'Members' : 'Lead' }}-->
<!--            </label>-->
<!--            <multi-select-custom-->
<!--              v-if="newAuditor.is_lead === true"-->
<!--              id="members-data"-->
<!--              :items="nonLeadAuditors" :entity="'Members'"-->
<!--              @doneSelected="setNonLeadMembers"-->
<!--              :selected="newAuditor.members_ids">-->
<!--            </multi-select-custom>-->
<!--            <multi-select-custom-->
<!--              v-else-->
<!--              id="lead-data"-->
<!--              :items="leadAuditors" :entity="'Lead'"-->
<!--              @doneSelected="setLeadMembers"-->
<!--              :selected="newAuditor.lead_ids">-->
<!--            </multi-select-custom>-->
<!--          </div>-->
          <!--          FOR AUDITOR CERTIFICATE -->
          <div class="form-group row no-gutters mb-1">
            <label class="font-weight-bold col-sm-3 col-form-label">Auditor Certificates</label>
            <div class="col-sm-9 d-flex align-items-center">
              <button type="button" class="btn btn-sm btn-success" onclick="document.getElementById('file-input').click()">
                Add Attachments
              </button>
              <input type="file" multiple class="d-none" id="file-input" ref="auditor_certificate" accept="application/pdf" @change="setAuditorCertificate">
              <span class="ml-2" v-if="newAuditor.certificates.length > 0">
      {{ newAuditor.certificates.length }} file{{ newAuditor.certificates.length === 1 ? '' : 's' }}
    </span>
            </div>
          </div>

          <div class="row">
            <div v-for="(certificate, index) in newAuditor.certificates" :key="index" class="col-12 col-md-6 mb-3">
              <div class="p-2 border rounded">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="font-weight-bold">
                    <font-awesome-icon icon="file-pdf" size="2x" class="force-danger-all mr-2"/>
                    <span :title="certificate.file_name">
                       {{ truncateText(certificate.file_name, 30) }}
                    </span>
                  </p>
                  <button type="button" class="btn btn-sm btn-secondary position-absolute" style="top: 0; right: 0; margin-top: 0px; margin-right: 15px;" @click="removeNewCertificate(index)">
                    X
                  </button>
                </div>
                <div class="form-group row no-gutters mb-1">
                  <label :for="'issued_date-' + index" class="font-weight-bold col-sm-4 col-form-label">Issued Date</label>
                  <div class="col-sm-8">
                    <input type="date" :id="'issued_date-' + index" class="form-control form-control-sm" v-model="certificate.issued_date" @keydown.enter.prevent>
                  </div>
                </div>
                <div class="form-group row no-gutters mb-1">
                  <label :for="'expiration_date-' + index" class="font-weight-bold col-sm-4 col-form-label">Expiry Date</label>
                  <div class="col-sm-8">
                    <input type="date" :id="'expiration_date-' + index" class="form-control form-control-sm" v-model="certificate.expiration_date" @keydown.enter.prevent>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary" ref="NewUser_close" @click.prevent="cancelAdd" :disabled="isSubmitting">Close</button>
          <button type="submit" class="btn btn-sm btn-primary" :disabled="isSubmitting">
            {{ isSubmitting ? 'Creating...' : 'Create Auditor' }}
          </button>
        </div>
      </form>
    </div>
  </div>

</template>

<style scoped>
.dropdown-item {
  padding-left: 12px;
}
</style>
